import { Component } from '@angular/core';
import { ActionResult } from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-save-novi-korisnik-citaonice',
  templateUrl: './save-novi-korisnik-citaonice.component.html'
})
export class SaveNoviKorisnikCitaoniceComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  protected override doExecute(): Observable<ActionResult> {
    // EARH-3769: Osvježavamo stranicu samo nakon uspješnog spremanja.
    // Prije se reload radio u finalize() koji se izvršava i kod greške, pa je
    // kod validacijske greške (npr. dupli korisnik ili već postojeća e-pošta)
    // dolazilo do punog reloada koji je zatvarao dijalog i uklanjao poruku o
    // grešci prije nego ju je korisnik mogao vidjeti. Sada se kod greške
    // observable prekida s greškom -> poruka ostaje vidljiva, dijalog ostaje otvoren.
    return super.doExecute().pipe(
      tap({
        next: () => {
          //FIXME: fix reload without location.href
          location.href = location.href;
        }
      })
    );
  }
}
